import PageTitle from "components/PageTitle/PageTitle";
import PageFrame from "components/Panels/PageFrame";
import { getNowServiceState } from "pages/NoticeBoard/model/board_row";
import React from "react";
import NoticeWrapper from "./NoticeWrapper";

const NoticeService = () => {
  const nowService = "공지사항";
  return (
    <div>
      <PageFrame
        children={
          <div>
            <PageTitle titleText="공지사항" />
            <NoticeWrapper nowService={getNowServiceState(nowService)} />
          </div>
        }
      />
    </div>
  );
};
export default NoticeService;
